/**
 * Arabic has six plural categories (zero, one, two, few, many, other), and
 * i18next asks for the one the count falls in. Most Arabic strings here are
 * written count-agnostic in `_other` ("الجلسات المحضورة: {{count}}"), so a
 * group carrying only `_one`/`_other` is complete in meaning. Without this,
 * though, a count of 0, 2 or 3–10 misses its form and i18next falls back to the
 * ENGLISH string, so an Arabic screen reads "0 sessions attended".
 *
 * Fills each missing zero/two/few/many from the group's `_other`. Forms a
 * translator wrote are never touched.
 */
const ARABIC_EXTRA = ['zero', 'two', 'few', 'many'] as const;

export function withArabicPlurals<T extends Record<string, unknown>>(tree: T): T {
  const out: Record<string, unknown> = {};
  for (const [k, v] of Object.entries(tree)) {
    out[k] = v && typeof v === 'object' && !Array.isArray(v) ? withArabicPlurals(v as Record<string, unknown>) : v;
  }
  for (const [k, v] of Object.entries(tree)) {
    if (!k.endsWith('_other') || typeof v !== 'string') continue;
    const base = k.slice(0, -'_other'.length);
    for (const form of ARABIC_EXTRA) {
      if (!(`${base}_${form}` in out)) out[`${base}_${form}`] = v;
    }
  }
  return out as T;
}
